import React from "react";
import { Loader2 } from "lucide-react";

/**
 * Shared loading / empty / error state for every board card type.
 * All colors via CSS design tokens.
 */
export default function BoardCardState({ state, message }) {
  if (state === "loading") {
    return (
      <div className="flex flex-1 min-h-0 w-full items-center justify-center">
        <div className="flex items-center gap-2 text-[color:var(--text-muted)]">
          <Loader2 className="h-4 w-4 animate-spin shrink-0" />
          <span style={{ fontSize: 13, fontFamily: "Inter, sans-serif" }}>Loading…</span>
        </div>
      </div>
    );
  }

  if (state === "error") {
    return (
      <div className="flex flex-1 min-h-0 w-full items-center justify-center px-4">
        <p
          className="text-center text-[13px] text-[color:var(--feedback-error)]"
          style={{ fontFamily: "Inter, sans-serif" }}
        >
          {message || "Could not load data"}
        </p>
      </div>
    );
  }

  if (state === "empty") {
    return (
      <div className="flex flex-1 min-h-0 w-full items-center justify-center px-4">
        <p
          className="text-center text-[13px] text-[color:var(--text-muted)]"
          style={{ fontFamily: "Inter, sans-serif" }}
        >
          {message || "No data to display"}
        </p>
      </div>
    );
  }

  return null;
}
